import React, { useState } from 'react';
import Card from '../../components/common/Card/Card';
import ImagePlaceholder from '../../components/common/ImagePlaceholder/ImagePlaceholder';
import Modal from '../../components/common/Modal/Modal';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import { WORKSHOPS_DATA } from '../../constants/workshopsData';
import './Workshops.css';

/**
 * Página de Talleres - Colegio Bertolt Brecht
 */
const Workshops = () => {
    const [selectedWorkshop, setSelectedWorkshop] = useState(null);

    const handleViewDetails = (workshop) => {
        setSelectedWorkshop(workshop);
    };

    const closeModal = () => {
        setSelectedWorkshop(null);
    };

    return (
        <div className="workshops">
            {/* Page Header */}
            <PageHeader
                title="Talleres"
                subtitle="Actividades extracurriculares que complementan la formación integral de nuestros estudiantes"
            />

            <div className="container">
                {/* Talleres Grid */}
                <section className="workshops__grid-section">
                    <div className="workshops__grid">
                        {WORKSHOPS_DATA.map((workshop, index) => (
                            <Card
                                key={workshop.id}
                                hoverable
                                className={`workshops__card animate-scale-in animate-delay-${Math.min(index + 1, 4)}`}
                            >
                                <div className={`workshops__card-header workshops__card-header--${workshop.color}`}>
                                    <div className="workshops__card-icon">{workshop.icon}</div>
                                    <h2>{workshop.title}</h2>
                                </div>
                                <div className="workshops__card-body">
                                    <p className="workshops__card-description">{workshop.description}</p>
                                    <h4>Beneficios:</h4>
                                    <ul className="workshops__card-benefits">
                                        {workshop.benefits.map((benefit, idx) => (
                                            <li key={idx}>{benefit}</li>
                                        ))}
                                    </ul>
                                    <button
                                        className="workshops__view-details"
                                        onClick={() => handleViewDetails(workshop)}
                                    >
                                        Ver detalles →
                                    </button>
                                </div>
                            </Card>
                        ))}
                    </div>
                </section>

                {/* Información Adicional */}
                <section className="workshops__info animate-fade-in">
                    <div className="workshops__info-content">
                        <h2>¿Por qué participar en nuestros talleres?</h2>
                        <div className="workshops__info-grid">
                            <div className="workshops__info-item">
                                <div className="workshops__info-icon">🌟</div>
                                <h3>Desarrollo Integral</h3>
                                <p>Complementan la formación académica con habilidades artísticas, deportivas y sociales</p>
                            </div>
                            <div className="workshops__info-item">
                                <div className="workshops__info-icon">👥</div>
                                <h3>Socialización</h3>
                                <p>Fomentan el trabajo en equipo y las relaciones interpersonales</p>
                            </div>
                            <div className="workshops__info-item">
                                <div className="workshops__info-icon">💪</div>
                                <h3>Confianza</h3>
                                <p>Desarrollan la autoestima y seguridad en las propias capacidades</p>
                            </div>
                            <div className="workshops__info-item">
                                <div className="workshops__info-icon">🎯</div>
                                <h3>Descubrimiento</h3>
                                <p>Ayudan a descubrir talentos y pasiones personales</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Galería de Actividades */}
                <section className="workshops__gallery animate-slide-up">
                    <h2 className="text-center">Nuestras Actividades</h2>
                    <div className="workshops__gallery-grid">
                        <ImagePlaceholder
                            aspectRatio="4/3"
                            icon="🎵"
                            alt="Música"
                        />
                        <ImagePlaceholder
                            aspectRatio="4/3"
                            icon="⚽"
                            alt="Deportes"
                        />
                        <ImagePlaceholder
                            aspectRatio="4/3"
                            icon="🌍"
                            alt="Inglés"
                        />
                        <ImagePlaceholder
                            aspectRatio="4/3"
                            icon="🎤"
                            alt="Oratoria"
                        />
                    </div>
                </section>
            </div>

            {/* Modal de Detalle de Taller */}
            <Modal
                isOpen={!!selectedWorkshop}
                onClose={closeModal}
                title={selectedWorkshop?.title || ''}
                size="lg"
            >
                {selectedWorkshop && (
                    <div className="workshop-modal">
                        <div className="workshop-modal__image">
                            <ImagePlaceholder
                                src={selectedWorkshop.image}
                                aspectRatio="16/9"
                                icon={selectedWorkshop.icon}
                                alt={selectedWorkshop.imageAlt || selectedWorkshop.title}
                            />
                        </div>
                        <div className="workshop-modal__info">
                            <div className="workshop-modal__info-item">
                                <strong>📅 Horario:</strong> {selectedWorkshop.schedule}
                            </div>
                            <div className="workshop-modal__info-item">
                                <strong>👨‍🏫 Instructor:</strong> {selectedWorkshop.instructor}
                            </div>
                            <div className="workshop-modal__info-item">
                                <strong>📊 Nivel:</strong> {selectedWorkshop.level}
                            </div>
                        </div>
                        <div className="workshop-modal__description">
                            {selectedWorkshop.fullDescription.split('\n').map((paragraph, index) => (
                                paragraph.trim() && <p key={index}>{paragraph}</p>
                            ))}
                        </div>
                        <div className="workshop-modal__benefits">
                            <h3>Beneficios del taller:</h3>
                            <ul>
                                {selectedWorkshop.benefits.map((benefit, idx) => (
                                    <li key={idx}>{benefit}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                )}
            </Modal>
        </div>
    );
};

export default Workshops;
